module.exports = __webpack_public_path__ + "images/scholarship-image.png";